<template>
  <div>
    <div class="container-fluid" style="height: 800px">
      <Modal @closeDialog="visible = false" :visible="visible" :errorMessage="resultMessage"></Modal>
      <div class="row">
        <h2 class="table-name">Editing {{ readableName(table) }} </h2>
        <div v-if="loading" class="fa-3x text-center">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <QueryBuilder :rules="rules" :getFilteredData="getFilteredData" ref="qb"></QueryBuilder>
        <HandsOnTable :hotdata="hotdata" :descriptions="descriptions" :table="table" :columns="columnMetaData"></HandsOnTable>

        <div class="card mb-3">
          <div class="card-body">
            <h2 class="card-title">On Selected:</h2>
            <form>
              <div class="row">
                <div class="custom-control custom-radio col-md-2 col-xs-6">
                  <input type="radio" class="custom-control-input" value="deactivate" name="modifyUserRadioButtons" v-model="picked" />
                  <label class="custom-control-label" for="deactivate">&nbsp;Deactivate user</label>
                </div>
              </div>
              <div class="row">
                <div class="custom-control custom-radio col-md-2 col-xs-12">
                  <input type="radio" class="custom-control-input" value="reactivate" name="modifyUserRadioButtons" v-model="picked" />
                  <label class="custom-control-label" for="reactivate">&nbsp;Reactivate user</label>
                </div>
              </div>

              <div v-if="table === 'users'">
              <div class="row">
                <div class="custom-control custom-radio col-md-2 col-xs-12">
                  <input type="radio" class="custom-control-input" value="resetAPIKey" name="modifyUserRadioButtons" v-model="picked" />
                  <label class="custom-control-label" for="resetAPIKey">&nbsp;Reset API Key</label>
                </div>
              </div>

              <div class="row">
                <div class="custom-control custom-radio col-md-3 col-xs-6">
                  <input type="radio" class="custom-control-input" value="changeRole" name="modifyUserRadioButtons" v-model="picked" />
                  <label class="custom-control-label" for="changeRole">&nbsp;Change user role</label>
                  <div class="checkbox-container" id="roles-checkboxes-container"></div>
                </div>
              </div>

              <div class="row">
                <div class="custom-control custom-radio col-md-3 col-xs-6">
                  <input type="radio" class="custom-control-input" value="changeLimit" name="modifyUserRadioButtons" v-model="picked" />
                  <label class="custom-control-label" for="changeLimit">&nbsp;Change user limit</label>

                  <select class="selectpicker col-md-offset-1" id="selChangeLimit" v-model="userLimit">
                    <option id="1K daily" value="nqfa21">1K daily</option>
                    <option id="10K daily" value="e090ks">10K daily</option>
                  </select>
                </div>
              </div>
              </div> <!-- Ends v-if="table === 'users'" div -->
            </form>
            <div class="row col-md-4 col-xs-8">
              <button class="btn btn-default submit-btn" @click="submitUpdates">
                Submit updates
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HandsOnTable from "../components/UserHandsOnTable.vue";
import QueryBuilder from "../components/shared/QueryBuilder.vue";
import Modal from "./shared/Modal";
import getColumnMetaData from "../mixins/columnMetaData.js";
import getFiltersForSearch from "../mixins/filtersForSearch.js";
import readableName from '../mixins/readableName';
export default {
  name: "ModifyUsers",

  components: {
    HandsOnTable,
    QueryBuilder,
    Modal,
  },
  mixins: [getColumnMetaData, getFiltersForSearch, readableName],
  methods: {
    async getFilteredData() {
      let query = {};
      query.where = this.$refs.qb.query;
      query.table = this.$route.params.table;
      query.limit = this.limit;
      query.offset = this.offset;

      let headers = { "Content-Type": "application/json", Accept: "application/json" };

      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "POST",
        headers: headers,
        credentials: "include",
        body: JSON.stringify(query),
      });
      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json(); // Convert response to JSON

        if (response.success === true) {
          //this.hotdata = []; // Clear current table data.
          this.hotdata.splice(0, this.hotdata.length)
          response.data.forEach((item) => {
            item["columnselected"] = false;
            this.hotdata.push(item);
            
          });
        } else {
          this.resultMessage = "Error getting filtered data";
          this.visible = true;
          //console.log("ERROR IN FILTERED DATA RESPONSE");
        }
      }
    },
    async submitUpdates() {
    
      if (this.picked) {
        this.loading = true;
        this.allResults = null;

        // Create the newRole as a comma-separated string of roles from checkboxes
        if (this.$route.params.table == 'users'){
          let selectedRoles = [];
          this.roles.forEach(option => {
            let checkbox = document.getElementById('chk-role-' + option);
            if (checkbox.checked) {
              selectedRoles.push(checkbox.value);
            }
          });
          this.newRole = selectedRoles.join(',');
        }
        
        if (this.picked === "changeRole" && this.newRole) {
          this.allResults = await this.changeRole();
        } else if (this.picked === "deactivate") {
          this.allResults = await this.deactivate();
        } else if (this.picked === "reactivate") {
          this.allResults = await this.reactivate();
        } else if (this.picked === "resetAPIKey") {
          this.allResults = await this.resetAPIKey();
        } else if (this.picked === "changeLimit") {
          this.allResults = await this.changeUserLimit();
        }
        this.resultMessage = " ";
        if (this.allResults.length > 0) {
          for (const item of this.allResults) {
            this.resultMessage = `${this.resultMessage} \n ${item.message}`;
          }
        } else {
          this.resultMessage = "No records were chosen";
        }
        this.getFilteredData();
        this.loading = false;
        this.visible = true;
      }
    },
    async changeRole() {
      let resultsArray = new Array();
      for await (const item of this.hotdata) {
        if (item.columnselected) {
          const body = JSON.stringify({
            data: {
              id: item.id,
              role: this.newRole,
            },
          });

          let headers = { "Content-Type": "application/json", Accept: "application/json" };
          headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/change_role`;

          let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: body,
          });

          if (response.status == 403) {
            response = await response.json();
            alert(response.message);
            window.location.href = "/login";
          } else {
            response = await response.json();
            resultsArray.push(response);
          }
        }
      }
      return resultsArray;
    },
    createRolesCheckboxes(roles) {
      const container = document.getElementById('roles-checkboxes-container');
      roles.forEach(option => {
        let checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = 'chk-role-' + option;
        checkbox.value = option;

        let label = document.createElement('label');
        label.htmlFor = option;
        label.appendChild(document.createTextNode(option));

        container.appendChild(checkbox);
        container.appendChild(label);
        container.appendChild(document.createElement('br'));
      });
    },
    async deactivate() {
      
      let resultsArray = new Array();
      for await (const item of this.hotdata) {
        if (item.columnselected) {
          const body = JSON.stringify({
            id: item.id,
          });
         
          let headers = { "Content-Type": "application/json", Accept: "application/json" };
          if (this.$route.params.table == 'users'){
             headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/deactivate_user`;
          }else if (this.$route.params.table == 'data_sales_users'){
             headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/deactivate_user`;
          }

          let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: body,
          });

          if (response.status == 403) {
            response = await response.json();
            alert(response.message);
            window.location.href = "/login";
          } else {
            response = await response.json();
            resultsArray.push(response);
          }
        }
      }

      return resultsArray;
    },
    async getValidUserRoles() {
      let resultsArray = new Array();
      let results = null;
    
      let headers = { "Content-Type": "application/json", Accept: "application/json" };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/get_valid_user_roles`;

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "GET",
        headers: headers,
        credentials: "include",
      });

      results = await response.json();
      if (response.status == 403) {
        alert(results.message);
        window.location.href = "/login";
      } else {
        if (results.data.valid_roles) {
          resultsArray = results.data.valid_roles;
        }
      }
      return resultsArray;
    },
    async reactivate() {
      let resultsArray = new Array();
      for await (const item of this.hotdata) {
        if (item.columnselected) {
          const body = JSON.stringify({
            id: item.id,
          });

          let headers = { "Content-Type": "application/json", Accept: "application/json" };

          if (this.$route.params.table == 'users'){
            headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/reactivate_user`;
          } else if (this.$route.params.table == 'data_sales_users'){
             headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/reactivate_user`;
          }  

          let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: body,
          });

          if (response.status == 403) {
            response = await response.json();
            alert(response.message);
            window.location.href = "/login";
          } else {
            response = await response.json();
            resultsArray.push(response);
          }
        }
      }
      return resultsArray;
    },
    async resetAPIKey() {
      let resultsArray = new Array();
      for await (const item of this.hotdata) {
        if (item.columnselected) {
          const body = JSON.stringify({
            email: item.email,
          });

          let headers = { "Content-Type": "application/json", Accept: "application/json" };
          headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/reset_api_key`;

          let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: body,
          });

          if (response.status == 403) {
            response = await response.json();
            alert(response.message);
            window.location.href = "/login";
          } else {
            response = await response.json();
            resultsArray.push(response);
          }
        }
      }

      return resultsArray;
    },
    async changeUserLimit() {
      let resultsArray = new Array();
      for await (const item of this.hotdata) {
        if (item.columnselected && this.userLimit) {
          const body = JSON.stringify({
            id: item.id,
            usage_plan: this.userLimit,
          });

          let headers = { "Content-Type": "application/json", Accept: "application/json" };
          headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/change_user_limit`;

          let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: body,
          });

          if (response.status == 403) {
            response = await response.json();
            alert(response.message);
            window.location.href = "/login";
          } else {
            response = await response.json();
            resultsArray.push(response);
          }
        }
      }

      return resultsArray;
    },
  },
  data() {
    return {
      descriptions: ["Some column description", "Some Other column Description", "Another column Description"],
      hotdata: [],
      columnMetaData: [],
      table: this.$route.params.table,
      loading: false,
      limit: 25,
      offset: 0,
      rules: [],
      query: null,
      picked: null,
      labels: {
        matchType: "Match Type",
        matchTypes: [
          { id: "all", label: "All of the filters" },
          { id: "any", label: "Any of the filters" },
        ],
        addRule: "Add Filter",
      },
      depth: 1,
      newRole: null,
      allResults: null,
      userLimit: null,
      resultMessage: "",
      visible: false,
      isChecked: true,
      roles: ['api_reader', 'api_writer', 'api_admin']
    };
  },
  selectDeselectAll: () => {
    this.hotdata.forEach((item) => {
      item.columnselected = !item.columnselected;
    });
  },

  mounted: async function() {
    // Before we push any data into HOT, first we use the schema and hotConfig to configure the search filters & columns.
    this.rules = await this.generateFiltersForSearch();
    this.generateColumnMetaData("Edit", this.table);
    this.loading = true;

    if (this.$route.params.table == 'users') {
      this.roles = await this.getValidUserRoles();
      this.createRolesCheckboxes(this.roles);
    }

    if (window.location.href.indexOf("where") > -1) {
      let query = JSON.parse(
        JSON.stringify(decodeURIComponent(window.location.href ? window.location.href.split("?")[1] : window.location.search.slice(1)))
      );
      this.$refs.qb.query = JSON.parse(query).where;
      this.$refs.qb.showSearch = true;
      this.getFilteredData();
      this.loading = false;
    } else {
      this.table = this.$route.params.table;
      this.limit = 50;
      this.getFilteredData();
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.page-select,
.record-number {
  width: 75px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}

.btn {
  margin-top: 30px;
  margin-bottom: 20px;
}

.btn-default {
  margin-right: 10px;
}

.btn-hide {
  margin-right: 0px;
  margin-bottom: 10px;
  margin-top: 0px;
}

.btn-share,
.btn-search {
  margin-bottom: 2px;
  width: 125px;
}

.submit-btn {
  width: 30%;
}

.checkbox {
  margin-top: 0px;
}

.checkbox-container {
  border: 2px solid #000;
  margin-left: 20px;
  padding-left: 5px;
}

h3 {
  margin-bottom: 20px;
}
label {
  padding-top: 5px;
}

.table-name {
  text-align: left;
}
.container-fluid {
  margin-right: 3%;
  margin-left: 5%;
}
.show-search {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
